// admin.luwu.dev: the staff site. Each page is its own HTML file from one
// template, with data-page on <body>; this picks the view. Who gets in and
// what they may change is decided by the control plane (GET /v1/admin/me
// says the role; the site only hides controls).

import { ACCOUNTS, isOwner, loadMe, post, setToken, signedIn } from "./api";
import { alarmsPage } from "./pages/alarms";
import { blocksPage } from "./pages/blocks";
import { logsPage } from "./pages/logs";
import { mePage } from "./pages/me";
import { nodePage } from "./pages/node";
import { nodesPage } from "./pages/nodes";
import { orderPage } from "./pages/order";
import { ordersPage } from "./pages/orders";
import { overview } from "./pages/overview";
import { routingPage } from "./pages/routing";
import { staffPage } from "./pages/staff";
import { userPage } from "./pages/user";
import { usersPage } from "./pages/users";
import { $, days, link, setDays, show, view } from "./ui";

const PAGE = document.body.dataset.page ?? "overview";
let email = "";

$<HTMLFormElement>("f-email").addEventListener("submit", async (e) => {
  e.preventDefault();
  const err = $("e-email");
  err.textContent = "";
  email = $<HTMLInputElement>("email").value.trim();
  if (!email.includes("@")) return void (err.textContent = "Enter your email address.");
  try {
    await post(`${ACCOUNTS}/v1/auth/email/start`, { email });
    $("sent-to").textContent = email;
    view("code");
    $<HTMLInputElement>("code").focus();
  } catch (x) {
    err.textContent = (x as Error).message;
  }
});
$<HTMLFormElement>("f-code").addEventListener("submit", async (e) => {
  e.preventDefault();
  const err = $("e-code");
  err.textContent = "";
  try {
    const r = await post<{ token?: string }>(`${ACCOUNTS}/v1/auth/email/verify`, { email, code: $<HTMLInputElement>("code").value.trim(), deviceName: "Luwu admin" });
    if (!r.token) return void (err.textContent = "There's no account for this email. Sign in to the Luwu app once first.");
    setToken(r.token);
    void render();
  } catch (x) {
    err.textContent = (x as Error).message;
  }
});
for (const id of ["sign-out", "sign-out-2"]) {
  $(id).addEventListener("click", () => {
    setToken(null);
    $("nav-staff").hidden = true;
    view("email");
  });
}
$("back").addEventListener("click", () => view("email"));
for (const b of document.querySelectorAll<HTMLButtonElement>("[data-days]")) {
  b.setAttribute("aria-pressed", String(Number(b.dataset.days) === days()));
  b.addEventListener("click", () => {
    setDays(Number(b.dataset.days));
    for (const x of document.querySelectorAll<HTMLButtonElement>("[data-days]")) x.setAttribute("aria-pressed", String(Number(x.dataset.days) === days()));
    void render();
  });
}
for (const a of document.querySelectorAll<HTMLAnchorElement>("nav.tabs a")) {
  const parent: Record<string, string> = { user: "users", order: "orders", node: "nodes" };
  if (a.dataset.page === PAGE || a.dataset.page === parent[PAGE]) a.setAttribute("aria-current", "page");
}

const pages: Record<string, () => Promise<unknown>> = {
  overview,
  users: usersPage,
  user: userPage,
  nodes: nodesPage,
  node: nodePage,
  routing: routingPage,
  orders: ordersPage,
  order: orderPage,
  blocks: blocksPage,
  logs: logsPage,
  alarms: alarmsPage,
  staff: staffPage,
  me: mePage,
};

async function render() {
  if (PAGE === "notfound") return show("Not found", "There's no page at this address.", link("/", "← Overview"));
  if (!signedIn()) return view("email");
  view("loading");
  $("loading-msg").textContent = "Loading…";
  const me = await loadMe();
  if (!me) return;
  $("nav-staff").hidden = !isOwner();
  await (pages[PAGE] ?? overview)();
}

void render();
